import { render, staticRenderFns } from "./CharUsersPie.vue?vue&type=template&id=ecb9e8be&"
import script from "./CharUsersPie.vue?vue&type=script&lang=js&"
export * from "./CharUsersPie.vue?vue&type=script&lang=js&"
import style0 from "./CharUsersPie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports